module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-demo",
    attrs: {
      "id": "locked-modal"
    }
  }, [_c('h4', {
    staticClass: "custom-modal-title"
  }, [_vm._v("Session verrouillée")]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-text"
  }, [_c('gravatar', {
    staticClass: "img-circle center-block m-b-10",
    attrs: {
      "email": _vm.user.email,
      "alt": "user"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('p', [_vm._v("\n      Votre session de travail a été verrouillée manuellement ou automatiquement pour cause d'inactivité.\n      Pour vous re-connecter, cliquez simplement sur le bouton reconnexion ci-dessous.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-30 m-b-5"
  }, [_c('el-button', {
    staticClass: "waves-effect waves-light",
    staticStyle: {
      "display": "block",
      "margin": "auto"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Reconnexion")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bc96ca0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/LockedModal.vue
// module id = 697
// module chunks = 1